module.exports = __webpack_public_path__ + "static/img/changwen.57e33a87.svg";